import { routes, useCurrentUser, useRouter } from '@builddocs/data-management'
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks'
import { Link as LinkRouter } from 'react-router-dom'

export const ProfileField = () => {
  const theme = useTheme()
  const { user } = useCurrentUser()
  const { navigate } = useRouter()
  const logout = () => {
    navigate(routes.auth.logout())
  }

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'popover-notifications',
  })

  const bindPopoverProps = bindPopover(popupState)

  return (
    <Stack alignItems="flex-end" data-testid="profile-field" id="profile-field">
      <Tooltip title="Меню">
        <ListItem
          disablePadding
          sx={{ width: 'fit-content', display: 'flex', pr: 0.5 }}
        >
          <ListItemButton
            data-testid="profile-field-button"
            selected={popupState.isOpen}
            sx={{
              gap: 1,
              borderRadius: { xs: '50%', md: 2 },
              py: { xs: 0.5, md: 0.5 },
              px: { xs: 0.5, md: 1 },
            }}
            {...bindTrigger(popupState)}
          >
            <ListItemText
              primary={[user.firstName, user.lastName].join(' ')}
              primaryTypographyProps={{
                lineHeight: 1.35,
                color: 'text.primary',
              }}
              secondary={
                user.employment?.position.description ?? 'Без должности'
              }
              secondaryTypographyProps={{ lineHeight: 1.35 }}
              sx={{
                textAlign: 'right',
                margin: 0,
                display: { xs: 'none', md: 'initial' },
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                height: '100%',
              }}
            />
            <ListItemAvatar sx={{ minWidth: 28 }}>
              <Avatar
                src=""
                sx={{
                  backgroundColor: 'transparent',
                  height: 32,
                  width: 32,
                  borderWidth: 2,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  svg: {
                    backgroundColor: 'grey.300',
                    color: 'grey.900',
                    width: '100%',
                    height: '100%',
                    p: 0.5,
                  },
                  transition: theme.transitions.create([
                    'border-color',
                    'transform',
                  ]),
                  ...(bindPopoverProps.open && {
                    borderColor: 'primary.main',
                  }),
                }}
                variant="circular"
              />
            </ListItemAvatar>
          </ListItemButton>
        </ListItem>
      </Tooltip>
      <Menu
        {...bindPopoverProps}
        MenuListProps={{ sx: { minWidth: 128 } }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        data-testid="profile-field-menu"
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          {...{ to: routes.account.base(), component: LinkRouter }}
          sx={{
            '& a': {
              color: 'text.primary',
              textDecoration: 'none',
              width: '100%',
            },
          }}
          onClick={() => popupState.setOpen(false)}
        >
          <Typography>Профиль</Typography>
        </MenuItem>
        <MenuItem onClick={logout}>
          <Typography>Выйти</Typography>
        </MenuItem>
      </Menu>
    </Stack>
  )
}

export default ProfileField
